export const PROGRAM_APPLIANCE_CATEGORY = {
  AC_UNIT_NON_INFRARED: "AC_UNIT_NON_INFRARED",
  HEATER: "HEATER",
  WATER_HEATER: "WATER_HEATER",
} as const;

export enum EOtherApplianceCategory {
  OTHER = "OTHER",
}

export type TProgramApplianceCategory = (typeof PROGRAM_APPLIANCE_CATEGORY)[keyof typeof PROGRAM_APPLIANCE_CATEGORY];

export type TSectionApplianceCategory = TProgramApplianceCategory | EOtherApplianceCategory.OTHER;

export type TApplianceCountByProgrammingCategory = Partial<Record<string, number>>;

export const categoryOrder: TSectionApplianceCategory[] = [
  PROGRAM_APPLIANCE_CATEGORY.HEATER,
  PROGRAM_APPLIANCE_CATEGORY.WATER_HEATER,
  PROGRAM_APPLIANCE_CATEGORY.AC_UNIT_NON_INFRARED,
  EOtherApplianceCategory.OTHER,
];

export interface ISectionApplianceCardAppliance {
  applianceId: number | string;
  category: string;
  name: string;
}
